<div class="flex-auto w-full relative -mb-1.25 pointer-events-none z-0">
	<ng-content select="[~bg]"></ng-content>
</div>

<div
	class="menu border-t border-t-line-230 overflow-hidden w-full shadow-z2 flex flex-col items-stretch justify-start z-1"
	[class.bg-280]="!lightBg"
	[class.bg-180]="lightBg"
	#menu
	(click)="stopEvent($event)"
	(transitionend)="onTransitionEnd($event)"
>
	@if (showHeader) {
		<div class="px-2 flex-none w-full box-border">
			<div
				class="header flex-none w-full flex items-center justify-start"
				[reachPan]="reachPanActive"
				(reachPanMove)="panMove($event)"
				(reachPanFinish)="panFinish($event)"
				(reachPanCancel)="panCancel()"
			>
				<div
					#leftOption
					class="legacy-option left flex-none flex justify-start items-center [.hide-left-option_&]:hidden"
				>
					<ng-content select="[~left]"></ng-content>
				</div>

				<div
					class="title flex-auto pl-2 pr-2 box-border flex items-center justify-center text-l fc-800 font-bold truncate text-center [.no-title-right-padding_&]:pr-0 [.hide-left-option_&]:pl-0 [.hide-right-option_&]:pr-0"
				>
					<ng-content select="[~title]"></ng-content>
				</div>

				<div
					#rightOption
					class="legacy-option right flex-none flex justify-end items-center [.hide-right-option_&]:hidden"
				>
					<ng-content select="[~right]"></ng-content>
				</div>
			</div>
		</div>
	}

	<ng-content select="[~over-content]"></ng-content>

	<div
		class="flex-auto w-full flex relative flex-col items-stretch justify-start scrollbar-fade overflow-auto"
		cdkScrollable
	>
		<div
			class="content-wrapper w-full flex flex-col justify-start items-stretch box-border scrollbar-fade overflow-auto"
			[class.px-1]="lightBg"
			[class.bg-190]="darkBg"
		>
			<ng-content></ng-content>
		</div>
	</div>
	@if (showFooter) {
		<ng-content select="[~footer]"></ng-content>
	}
</div>
